var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by karen on 13.04.16.
 */

/* global TYAPP_SURVEYS */
if ((typeof TYAPP_SURVEYS === 'undefined' ? 'undefined' : _typeof(TYAPP_SURVEYS)) !== 'object') {
	TYAPP_SURVEYS = {}; // eslint-disable-line no-global-assign
}

var activatingAnswers = {};
var thirdParties = {};
var activationRules = [],
    shareOnGooglePlaces = false,
    shareOnTripAdvisor = false,
    existQuestionRulesGoogle = false,
    existQuestionRulesTripadvisor = false;

/* Aux function to hide and uncheck 3rd party checkbox if there are existing rules for each case (Google or TripAdvisor)
	but the activation answers haven't been checked.
 */
var hideShareOnThirdParties = function () {
	if (existQuestionRulesGoogle) {
		$('#share_google_div').hide();
		$('#submit_to_google_places').prop('checked', false).prop('value', 'no');
	}
	if (existQuestionRulesTripadvisor) {
		$('#share_tripadvisor_div').hide();
		$('#submit_to_trip_advisor').prop('checked', false).prop('value', 'no');
	}
};

/* Aux function to show and check 3rd party checkbox if an activating question is answered
	Return true if any of the checkboxes was activated
 */
var showShareOnThirdParties = function (thirdPartyName) {
	// eslint-disable-line consistent-return
	if (thirdPartyName === 'Google') {
		if (shareOnGooglePlaces === true) {
			$('#share_google_div').show();
			$('#submit_to_google_places').prop('checked', true).prop('value', 'yes');
			return true;
		} else {
			$('#share_google_div').hide();
			$('#submit_to_google_places').prop('checked', false).prop('value', 'no');
			return false;
		}
	} else if (thirdPartyName === 'TripAdvisor') {
		if (shareOnTripAdvisor === true) {
			$('#share_tripadvisor_div').show();
			$('#submit_to_trip_advisor').prop('checked', true).prop('value', 'yes');
			return true;
		} else {
			$('#share_tripadvisor_div').hide();
			$('#submit_to_trip_advisor').prop('checked', false).prop('value', 'no');
			return false;
		}
	}
};

/* Main function that checks every answered custom question and activates the sharing on 3rd parties
   if there's at least one answer that triggers the 3rd party integration for Google or TripAdvisor.
 */
TYAPP_SURVEYS.updateThirdPartyIntegrationActivation = function (questionList) {
	for (var i = 0; i < questionList.length; i++) {
		var isActivatingQuestion = activatingAnswers.hasOwnProperty(questionList[i].id);
		if (isActivatingQuestion && $.inArray(questionList[i].value, activatingAnswers[questionList[i].id]) > -1) {
			if (showShareOnThirdParties(thirdParties[questionList[i].id])) {
				break;
			}
		}
		hideShareOnThirdParties();
	}
};

/* Function that checks if the sharing with Google or TripAdvisor is enabled, and also if there are activating rules
	for any of those 3rd parties. Also, takes the custom questions that have been answered so the main function can
	check if an answer is actually activating the push to a 3rd party.
 */
TYAPP_SURVEYS.checkThirdPartyActivationRules = function () {
	if (shareOnGooglePlaces === true || shareOnTripAdvisor === true || activationRules.length > 0) {
		// A custom question is answered and the value is provided. If it's a checkbox or radio it must be checked.
		var questionList = [];
		$('#cq-questions input').each(function () {
			var isCheckboxOrRadio = $.inArray(this.type, ['checkbox', 'radio']);
			if (isCheckboxOrRadio < 0 && this.value !== '' || isCheckboxOrRadio > -1 && this.checked) {
				questionList.push({
					id: this.id, value: this.value, type: this.type, other: this
				});
			}
		});
		// An option from a dropdown custom question is selected
		$('#cq-questions select').each(function () {
			questionList.push({
				id: this.id, value: this.value, type: this.type, other: this
			});
		});
		// A text area custom question is answered
		$('#cq-questions textarea').each(function () {
			if (this.value !== '') {
				questionList.push({
					id: this.id, value: this.value, type: this.type, other: this
				});
			}
		});
		TYAPP_SURVEYS.updateThirdPartyIntegrationActivation(questionList);
	}
};

/*	Prepares the 3rd party activator by initializing the variables needed for the main function. This is called at review_html_head.html
	when the push to Google or TripAdvisor is enabled and also when there are existing rules for the activation to the 3rd parties.
 */
TYAPP_SURVEYS.prepareThirdPartyActivator = function (thirdPartyActivationRules, existRulesGoogle, existRulesTA, shareOnGoogle, shareOnTA) {
	activationRules = thirdPartyActivationRules !== 'None' ? JSON.parse(thirdPartyActivationRules) : [];
	existQuestionRulesGoogle = existRulesGoogle === 'True';
	existQuestionRulesTripadvisor = existRulesTA === 'True';
	shareOnGooglePlaces = shareOnGoogle === 'True';
	shareOnTripAdvisor = shareOnTA === 'True';
	$.each(activationRules, function (index, rule) {
		activatingAnswers[rule.custom_question_id] = rule.activating_answers;
		thirdParties[rule.custom_question_id] = rule.collector_third_party_event;
	});
};